var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chartData.type === 'LINECHART')?_c('MediumLineChart',{attrs:{"chart-data":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }